/**
 * Extracts the numeric store ID from a route parameter.
 * Supports formats like "mad-edificio-espana_s14766.html", "301", etc.
 * @param {string} routeParam - The raw :id param from the URL
 * @returns {string|null} The store ID or null if not found
 */
export const extractStoreId = (routeParam) => {
  if (!routeParam) return null;

  const withSuffix = routeParam.match(/_s(\d+)/);
  if (withSuffix) return withSuffix[1];

  const numericOnly = routeParam.match(/\d+/);
  return numericOnly ? numericOnly[0] : null;
};
